import { useLocation, useNavigate } from "@tanstack/react-router"
import { Tabs, TabsList, TabsTrigger } from "design-system/molecules/Tabs"
import { useTranslation } from "react-i18next"

const tabOptions = [
  {
    value: "default",
    to: "/settings/channels/widget",
    labelKey: "campaigns.templates.widget.tabs.defaultWidget",
  },
  {
    value: "phoneMockup",
    to: "/settings/channels/widget/phone-mockup",
    labelKey: "campaigns.templates.widget.tabs.phoneMockup",
  },
] as const

export const WidgetConfigurationTabs = () => {
  const { t } = useTranslation()
  const { pathname } = useLocation()
  const navigate = useNavigate()
  const value = pathname.includes("/phone-mockup") ? "phoneMockup" : "default"

  return (
    <Tabs
      value={value}
      onValueChange={(nextValue) => {
        const nextTab = tabOptions.find((tab) => tab.value === nextValue)
        if (nextTab) {
          navigate({ to: nextTab.to })
        }
      }}
      className="w-fit"
    >
      <TabsList>
        {tabOptions.map((tab) => (
          <TabsTrigger key={tab.value} value={tab.value} className="px-4">
            {t(tab.labelKey)}
          </TabsTrigger>
        ))}
      </TabsList>
    </Tabs>
  )
}
